import { render, staticRenderFns } from "./voucherDetail.vue?vue&type=template&id=7ff0008c&scoped=true"
import script from "./voucherDetail.vue?vue&type=script&lang=js"
export * from "./voucherDetail.vue?vue&type=script&lang=js"
import style0 from "./voucherDetail.vue?vue&type=style&index=0&id=7ff0008c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff0008c",
  null
  
)

export default component.exports